import React, { useEffect } from 'react'
import { Alert, Box, CssBaseline } from '@mui/material'
import Footer from 'src/components/Footer'
import Header from 'src/components/Header'
import { useAppDispatch } from 'src/hooks/useRedux'
import { getAccessToken } from 'src/libs/redux/accessToken/accessToken.actions'

interface ILayoutProps {
  children: React.ReactNode
}

const BaseLayout: React.FC<ILayoutProps> = ({ children }) => {
  const dispatch = useAppDispatch()

  // fetch access token
  useEffect(() => {
    dispatch(getAccessToken())
  }, [])

  return (
    <Box sx={{ backgroundColor: 'bw.white' }}>
      <CssBaseline />
      <Alert
        severity="warning"
        sx={{
          borderRadius: 0,
          justifyContent: 'center',
          fontSize: '15px',
        }}
      >
        CSCS Smart Check will be unavailable between 10am and 2pm on Sunday,
        19th April 2026 while we carry out maintenance. We apologise for any
        inconvenience this may cause.
      </Alert>
      <Header />
      {children}
      <Footer />
    </Box>
  )
}

export default BaseLayout
